// extracted by mini-css-extract-plugin
module.exports = {"cell_badge":"LabelCell_cell_badge__2-gMU"};